import { Icon } from '@manychat/icons'

import { FlowChartButtonStatsBuilder } from 'common/builder/components/chart/FlowChart/lib/builders/FlowChartButtonStatsBuilder'
import {
  ButtonAppearance,
  FlowChartButton,
  FlowChartButtonStats,
} from 'common/builder/components/chart/FlowChart/types/FlowChartButton'
import { FlowChartNextStep } from 'common/builder/components/chart/FlowChart/types/FlowChartNextStep'

export class FlowChartButtonBuilder {
  private button: FlowChartButton

  constructor(id: string) {
    this.button = {
      id,
      caption: '',
      appearance: ButtonAppearance.DEFAULT,
      isInteractive: false,
      nextStep: null,
      icon: null,
      stats: new FlowChartButtonStatsBuilder().build(),
      isFallback: false,
    }
  }

  public withCaption(caption: string): FlowChartButtonBuilder {
    this.button.caption = caption
    return this
  }

  public withAppearance(appearance: ButtonAppearance): FlowChartButtonBuilder {
    this.button.appearance = appearance
    return this
  }

  public withIsInteractive(isInteractive: boolean): FlowChartButtonBuilder {
    this.button.isInteractive = isInteractive
    return this
  }

  public withNextStep(nextStep: FlowChartNextStep | null): FlowChartButtonBuilder {
    this.button.nextStep = nextStep
    return this
  }

  public withIcon(icon: Icon | null): FlowChartButtonBuilder {
    this.button.icon = icon
    return this
  }

  public withStats(stats: FlowChartButtonStats): FlowChartButtonBuilder {
    this.button.stats = stats
    return this
  }

  public withIsFallback(isFallback: boolean): FlowChartButtonBuilder {
    this.button.isFallback = isFallback
    return this
  }

  public build(): FlowChartButton {
    return this.button
  }
}
